export const migrations = {
  1: (state: any) => {
    return state;
  },
  2: (state: any) => {
    return {
      ...state,
      userController: {
        user: {
          id: -1,
          nome: "",
          cpf: "",
          perfisId: [],
          permissaoMenu: [],
        },
      },
      formularioControleResposta: {
        items: [],
        synced: false,
        updatedAt: 0,
      },
    };
  },
  3: (state: any) => {
    return {
      ...state,
      formularioControleResposta: {
        items: [],
        synced: false,
        updatedAt: 0,
      },
    };
  },
};
